import * as React from "react";
import { TextCard, OTRS } from "../frame/index.js";
import { Form, FormActions, Button } from "../form/index.js";
//import * as cls from "./ErrataView.module.scss";
export { ErrataView };
/**
 * Выводит отчёт об ошибках.
 *
 * Есть три кнопки:
 * - `Повторить`: Повторная отправка запроса.
 * - `Перезагрузить`: F5. Начинает занятие заново.
 * - `Поддержка`: Создаёт обращение в службу поддержки, содержащее текст ошибки
 *   и URL страницы, на которой она произошла.
 *
 * @summary Вывод отчёта об ошибках как секции учебного продукта.
 * @param {Object} props - Атрибуты элемента.
 * @param {Errata} props.errata - Отчёт об ошибке.
 * @returns {JSX.Element} Элемент JSX.
 * @example
 * import {ServiceError} from "../personal-studio-components/service/index.js";
 * if(request.hasError()) return <ServiceError errata={request.getErrata()}/>;
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function ErrataView({ errata = {} }) {
  OTRS.body = "";
  const style = error_type_style[errata.error_type] ?? error_type_style["*"];
  const error_list = [];
  for (const error_txt of errata.errors) {
    const error_html = error_txt.split("\n").map(
      (line, i) => <p key={i}>{line}</p>);
    error_list.push(<li key={error_txt}>{error_html}</li>);
    OTRS.body += error_txt.replace(/\n/g, "<br/>") + "<br/>";
  }
  let btnRetry = errata.retry ?
    <Button
      type="primary"
      icon="play_circle"
      onClick={(event) => { event.preventDefault(); errata.retry(); }}>
      Повторить
    </Button> : null;
  let btnReload =
    <Button
      icon="close_circle"
      onClick={(event) => { event.preventDefault(); location.reload(); }}>
      Перезагрузить
    </Button>;
  let btnSupport =
    <Button
      icon="chat"
      onClick={OTRS.onClick}>
      Техническая помощь
    </Button>;
  return (
    <Form onSubmit={btnRetry ? btnRetry.onClick : btnReload.onClick}>
      <TextCard type={style}>
        <ul className={undefined /*cls.error_list*/}>
          {error_list}
        </ul>
      </TextCard>
      <FormActions>
        {btnRetry} {btnReload} {btnSupport}
      </FormActions>
    </Form>
  );
}
const error_type_style = {
  "info": "default",
  "warning": "warning",
  "*": "danger"
};